import { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { shuffleArray } from "../../../../utils";
import Score0 from "./resources/score0.png";
import Score1 from "./resources/score1.png";
import Score2 from "./resources/score2.png";
import Score3 from "./resources/score3.png";
import Score4 from "./resources/score4.png";
import Score5 from "./resources/score5.png";
import Score6 from "./resources/score6.png";
import Score7 from "./resources/score7.png";
import Score8 from "./resources/score8.png";
import { ReactComponent as CircleSvg } from "../../../../SharedImages/Circle.svg";
import { ReactComponent as FlagSvg } from "../../../../SharedImages/Flag.svg";
import { ReactComponent as SkullSvg } from "../../../../SharedImages/Skull.svg";
import AudioControls from "../../GameComponents/AudioControls";
import audiobgm from "./resources/tug_of_war_bgm.mp3";
import "./TugOfWarPage.css";
import { API_BASE_URL, GAME_OPTIONS_PATH } from "../../../../constants";
import { FIREBASE_AUTH } from "../../../../FirebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { updateProgress, useVocabUnitData } from "../../../../database";

const BACKGROUND_IMAGES = [
  Score0,
  Score1,
  Score2,
  Score3,
  Score4,
  Score5,
  Score6,
  Score7,
  Score8,
];

function ScoreView() {
  return (
    <>
      <SkullSvg />
      <CircleSvg />
      <CircleSvg />
      <CircleSvg className="gray" />
      <CircleSvg />
      <CircleSvg />
      <CircleSvg />
      <CircleSvg />
      <FlagSvg />
    </>
  );
}

function TugOfWarPage() {
  const location = useLocation();
  const { unit, category } = location.state;

  const { data: vocabData, loading, error } = useVocabUnitData(unit.unit, unit.textbook);

  const [state, setState] = useState({
    questions: [],
    currQuestionIndex: 0,
    score: 3,
    answerLanguage: "korean",
  });
  const [user, setUser] = useState(null);
  
  const audioRefBgm = useRef(null);
  const [volume, setVolume] = useState(0.5);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    if (audioRefBgm.current) {
        audioRefBgm.current.volume = isMuted ? 0 : volume;
    }
  }, [volume, isMuted]);

  useEffect(() => {
    onAuthStateChanged(FIREBASE_AUTH, (user) => {
      setUser(user);
    });
  });

  useEffect(() => {
    if (!loading && vocabData.length > 0) {
      setState((prevState) => {
        if (JSON.stringify(prevState.questions) !== JSON.stringify(vocabData)) {
          return {
            ...prevState,
            questions: vocabData,
          };
        }
        return prevState;
      });
    }
  }, [vocabData, loading]);

  const questions = state.questions;
  const currQuestionIndex = state.currQuestionIndex;
  const answerLanguage = state.answerLanguage;
  const currScore = state.score;
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showCorrectMessage, setCorrectMessage] = useState(false);

  function openTutorial() {
    const pregameEl = document.getElementById("pregame");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");
    const gameEl = document.getElementById("game");

    if (pregameEl) pregameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "flex";
    if (postgameEl) postgameEl.style.display = "none";
    if (gameEl) gameEl.style.display = "none";
  }

  function closeTutorial() {
    const pregameEl = document.getElementById("pregame");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");

    if (pregameEl) pregameEl.style.display = "flex";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
  }

  function startGame() {
    const languageRadioButton = document.querySelector(
      'input[name="answer-language"]:checked'
    );
    if (languageRadioButton === null) {
      alert("Please select an answer language before starting the game");
      return;
    }
    const answerLanguage = languageRadioButton.value === "korean" ? "korean" : "englishLiterals";

    const pregameEl = document.getElementById("pregame");
    const postgameEl = document.getElementById("postgame");
    const tutorialEl = document.getElementById("tutorial");
    const winTextEl = document.getElementById("win-text");
    const loseTextEl = document.getElementById("lose-text");
    const scoreEl = document.getElementById("score");
    const gameEl = document.getElementById("game");
    const helpButtonEl = document.getElementById("tug-help-button");
    
    if (pregameEl) pregameEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (winTextEl) winTextEl.style.display = "none";
    if (loseTextEl) loseTextEl.style.display = "none";
    if (helpButtonEl) helpButtonEl.style.display = "none";

    const questions = state.questions;
    shuffleArray(questions);

    console.log(answerLanguage);

    setState({
      questions: questions,
      currQuestionIndex: 0,
      score: 3,
      answerLanguage: answerLanguage,
    });

    if (scoreEl) {
      const scoreChildren = scoreEl.childNodes;
      for (let i = 0; i < scoreChildren.length; i++) {
        if (scoreChildren[i]) {
          scoreChildren[i].classList.remove("red", "green");
        }
      }
      scoreEl.style.display = "flex";
    }
    if (gameEl) gameEl.style.display = "flex";

    if (audioRefBgm.current) {
        audioRefBgm.current.currentTime = 0;
        audioRefBgm.current.play().catch((err) => console.log("Audio autoplay blocked:", err));
    }
  }

  function submitAnswer() {
    const answerInputEl = document.getElementById("answer-input");
    if (!answerInputEl) return;
    
    const submission = answerInputEl.value;

    let correctAnswers = questions[currQuestionIndex][answerLanguage];
    if (!Array.isArray(correctAnswers)) {
      correctAnswers = [correctAnswers];
    }

    if (correctAnswers.includes(submission)) {
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "tug", true);
      }
      answerInputEl.value = "";
      setCorrectMessage(true);

      const newScore = currScore + 1;
      const scoreEl = document.getElementById("score");
      
      if (newScore === 8) {
        if (scoreEl && scoreEl.childNodes[newScore]) {
          scoreEl.childNodes[newScore].classList.add("green");
        }
        const gameEl = document.getElementById("game");
        const postgameEl = document.getElementById("postgame");
        const winTextEl = document.getElementById("win-text");
        if (gameEl) gameEl.style.display = "none";
        if (postgameEl) postgameEl.style.display = "flex";
        if (winTextEl) winTextEl.style.display = "flex";
        if (audioRefBgm.current) audioRefBgm.current.pause();
      } else if (newScore <= 3) {
        if (scoreEl && scoreEl.childNodes[newScore - 1]) {
          scoreEl.childNodes[newScore - 1].classList.remove("red");
        }
      } else if (newScore > 3) {
        if (scoreEl && scoreEl.childNodes[newScore]) {
          scoreEl.childNodes[newScore].classList.add("green");
        }
      }
      setTimeout(() => {
        setCorrectMessage(false);
        setState({
          ...state,
          currQuestionIndex:
            (state.currQuestionIndex + 1) % state.questions.length,
          score: newScore,
        });
      }, 2500);
    } else {
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "tug", false);
      }
      setShowErrorMessage(true);
      answerInputEl.value = "";
      const newScore = currScore - 1;
      setTimeout(() => {
        setShowErrorMessage(false);
        const scoreEl = document.getElementById("score");
        const gameEl = document.getElementById("game");
        const postgameEl = document.getElementById("postgame");
        const loseTextEl = document.getElementById("lose-text");
        
        if (newScore === 0) {
          if (scoreEl && scoreEl.childNodes[newScore]) {
            scoreEl.childNodes[newScore].classList.add("red");
          }
          if (gameEl) gameEl.style.display = "none";
          if (postgameEl) postgameEl.style.display = "flex";
          if (loseTextEl) loseTextEl.style.display = "flex";
          if (audioRefBgm.current) audioRefBgm.current.pause();
        } else if (newScore < 3) {
          if (scoreEl && scoreEl.childNodes[newScore]) {
            scoreEl.childNodes[newScore].classList.add("red");
          }
        } else if (newScore >= 3) {
          if (scoreEl && scoreEl.childNodes[newScore + 1]) {
            scoreEl.childNodes[newScore + 1].classList.remove("green");
          }
        }
        setState({
          ...state,
          currQuestionIndex:
            (state.currQuestionIndex + 1) % state.questions.length,
          score: newScore,
        });
      }, 6000);
    }
  }

  console.log(state.questions[state.currQuestionIndex]);

  // Wait for questions to load and ensure they're not empty
  if (loading || questions.length === 0) {
    return (
      <div className="loading-screen">
        <h2>Loading vocabulary questions...</h2>
      </div>
    );
  }

  // Show error message if data fetch failed
  if (error) {
    return (
      <div className="error-screen">
        <h2>Error loading vocabulary questions: {error}</h2>
      </div>
    );
  }

  return (
    <div id="tug-of-war-container">
      <audio 
        ref={audioRefBgm} 
        src={audiobgm} 
        loop 
      />
      <AudioControls 
        volume={volume} 
        setVolume={setVolume} 
        isMuted={isMuted} 
        setIsMuted={setIsMuted} 
      />
      <img
        className="background"
        src={BACKGROUND_IMAGES[state.score]}
        alt="Tug of War"
      />
      <div id="header">
        <button
          type="button"
          id="tug-help-button"
          className="tug-help-button"
          onClick={openTutorial}
          aria-label="Open Tug of War tutorial"
        >
          ?
        </button>
        <h1>{unit.name}</h1>
        <div id="score">
          <ScoreView />
        </div>
        <div id="pregame">
          <div id="settings">
            <b>Answer Language:</b>
            <input
              type="radio"
              id="korean"
              name="answer-language"
              value="korean"
            ></input>
            <label for="korean">Korean</label>
            <input
              type="radio"
              id="english"
              name="answer-language"
              value="english"
            ></input>
            <label for="english">English</label>
          </div>
          <button className="btn btn-primary" onClick={startGame}>
            Start Game
          </button>
        </div>
        <div id="game">
          {showErrorMessage && (
            <div id="error">
              <h2 id="error-message">Incorrect answer!</h2>
              <h3 id="error-message">
                The right answer is :{" "}
                {Array.isArray(questions[currQuestionIndex][answerLanguage])
                  ? questions[currQuestionIndex][answerLanguage].map(
                      (item, idx) => <li key={idx}>{item}</li>
                    )
                  : questions[currQuestionIndex][answerLanguage]}
              </h3>
            </div>
          )}
          {showCorrectMessage && (
            <div id="correct">
              <h2 id="correct-message">Correct answer! Good job!</h2>
            </div>
          )}
          <div id="question">
            <h2>
              What is{" "}
              <span id="question-text">
                {state.answerLanguage === "korean" ? (
                  <img
                    src={`${API_BASE_URL}/${questions[currQuestionIndex].imgPath}`}
                    width="180"
                    height="200"
                  />
                ) : (
                  state.questions[state.currQuestionIndex].korean
                )}
              </span>{" "}
              in {state.answerLanguage === "korean" ? "Korean" : "English"}?
            </h2>
          </div>
          <div id="answer">
            <input
              id="answer-input"
              type="text"
              autoComplete="off"
              onKeyDown={(event) => {
                if (event.key === "Enter") submitAnswer();
              }}
            />
            <button className="btn btn-primary" onClick={submitAnswer}>
              Submit
            </button>
          </div>
        </div>
        <div id="postgame">
          <h2 id="win-text">You win!</h2>
          <h2 id="lose-text">You lose!</h2>
          <button className="btn btn-primary" onClick={() => {
            const pregameEl = document.getElementById("pregame");
            const postgameEl = document.getElementById("postgame");
            const scoreEl = document.getElementById("score");
            const tutorialEl = document.getElementById("tutorial");
            const helpButtonEl = document.getElementById("tug-help-button");
            if (pregameEl) pregameEl.style.display = "flex";
            if (postgameEl) postgameEl.style.display = "none";
            if (scoreEl) scoreEl.style.display = "none";
            if (tutorialEl) tutorialEl.style.display = "none";
            if (helpButtonEl) helpButtonEl.style.display = "flex";
            if (audioRefBgm.current) audioRefBgm.current.pause();
          }}>
            Play Again
          </button>
        </div>
        <div id="tutorial">
        <h2>Tug of War Tutorial</h2>
        <p>
          <b>Goal:</b> Pull the score marker to the flag by answering correctly
          before it is dragged back to the skull.
        </p>
        <p>
          <b>How to Play:</b>
          <br />
          1. Pick your answer language before the round begins.
          <br />
          2. Read the word or image prompt on screen.
          <br />
          3. Type the matching translation in the correct language.
          <br />
          4. Submit each answer to move the rope in your direction.
        </p>
        <p>
          <b>Rules:</b>
          <br />
          Correct answers move the score toward the flag.
          <br />
          Wrong answers move the score back toward the skull.
          <br />
          The round ends when the score reaches the flag or the skull.
        </p>
        <p>
          <b>Tip:</b>
          <br />
          Watch whether the question is showing Korean text or an image so you
          know which translation you need to type.
        </p>
          <button className="btn btn-primary" onClick={closeTutorial}>
            Back to Game Setup
          </button>
        </div>
      </div>
      <Link
        to={GAME_OPTIONS_PATH}
        state={{ unit: unit, category: category }}
        className="game-options-back-link"
      >
        <button className="btn btn-back game-options-back-button">{"Back"}</button>
      </Link>
    </div>
  );
}

export default TugOfWarPage;
